export function arraysMatch<T>(x: T[], y: T[], itemsMatch: (i1: T, i2: T) => boolean): boolean {
    if (x.length !== y.length)
        return false;

    if (x.length === 0)
        return true;

    if (!x.every(xx => !!y.find(yy => itemsMatch(xx, yy))))
        return false;

    return true;
}
